import React, { useCallback } from "react";
import { IonCol, IonRow, IonSkeletonText } from "@ionic/react";

import classNames from "classnames/bind";
import styles from "./HomePageCategories.module.scss";
import { useHistory } from "react-router";
import { Image } from "../Image/Image";

import "swiper/scss/mousewheel";
import { useGetAllCategoriesQuery, useGetMainCategoriesQuery } from "../../providers/categories";
import { useConfig } from "../../providers/config";
import { CustomSlider } from "../CustomSlider/CustomSlider";
import Icons from "@core/icons";
import { Category } from "@core/types";
import { useTranslation } from "react-i18next";
const cx = classNames.bind(styles);

const categoriesSkeleton = [...Array(10).keys()];

const HomePageCategories = () => {
  const { t } = useTranslation();
  let history = useHistory();
  const config = useConfig();

  const { data: mainCategories } = useGetMainCategoriesQuery();
  const { data: { allCategories } = {} } = useGetAllCategoriesQuery();

  const openSubcategories = useCallback(
    (category: Category) => {
      if (allCategories?.filter((x: Category) => x.parent === category.id).length) {
        history.push("/categories/" + category.id + "/subcategories", { parentCategory: category });
      } else {
        history.push("/products/" + category.id + "/" + category.name + "/popular");
      }
    },
    [allCategories, history],
  );

  return (
    <div className={cx("row")}>
      {mainCategories?.length ? (
        <CustomSlider>
          <div className="flex gap-2 mt-1">
            {config?.showSliderCatalogButton && (
              <div className={cx("catalog__slide ")}>
                <div
                  className={cx("catalog")}
                  onClick={() => {
                    history.push("/search-main-categories");
                  }}
                >
                  <div className={cx("catalog__img-wrapper")}>
                    {Icons.catalog && (
                      <Image
                        draggable={false}
                        alt={"catalog"}
                        className={cx("catalog__img", "rounded-md")}
                        downsize={false}
                        lazyLoad={false}
                        src={Icons.catalog}
                      />
                    )}
                    <div className={cx("catalog__title")}>
                      <p>{t("Catalog")}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {mainCategories.map((category) => {
              return (
                <div key={category.id} className={cx("category__slide")}>
                  <div onClick={() => openSubcategories(category)} className={cx("category")}>
                    <div className={cx("category__img-wrapper")}>
                      <Image
                        draggable={false}
                        className={cx(
                          `${category.image?.src?.includes("catalog") ? "category__img_transform" : "category__img"}`,
                        )}
                        downsize={false}
                        lazyLoad={false}
                        src={category.image?.src}
                      />
                    </div>
                    <p className={cx("category__title")}>{category.name}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </CustomSlider>
      ) : (
        <IonCol size={"12"} className={"ion-no-padding ion-no-margin"}>
          <IonRow className={cx("skeleton")}>
            {categoriesSkeleton.map((skeleton) => {
              return (
                <IonCol key={skeleton} className={cx("skeleton__col")} size="3">
                  <IonSkeletonText className={cx("skeleton__text")} animated style={{ height: 70 }}></IonSkeletonText>
                  <IonSkeletonText className={cx("skeleton__text")} animated style={{ height: 10 }}></IonSkeletonText>
                  <IonSkeletonText
                    className={cx("skeleton__text")}
                    animated
                    style={{ height: 10, width: "50%" }}
                  ></IonSkeletonText>
                </IonCol>
              );
            })}
          </IonRow>
        </IonCol>
      )}
    </div>
  );
};

export default HomePageCategories;
